/* tslint:disable */
/* eslint-disable */
/**
 * NameCheck API
 * assembly version: 1.0.0.0
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * 
 * @export
 * @enum {string}
 */
export enum FileType {
    InvalidEnum = 'InvalidEnum',
    CV = 'CV',
    InterviewSheet = 'InterviewSheet'
}

export function FileTypeFromJSON(json: any): FileType {
    return FileTypeFromJSONTyped(json, false);
}

export function FileTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): FileType {
    return json as FileType;
}

export function FileTypeToJSON(value?: FileType | null): any {
    return value as any;
}

